import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchSite, imgUrl } from "../lib/api";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [site, setSite] = useState({ images: {}, gallery: [], loading: true });
  const load = useCallback(async () => {
    try {
      const d = await fetchSite();
      setSite({ images: d.images || {}, gallery: d.gallery || [], loading: false });
    } catch (e) {
      console.error("Failed to load site", e);
      setSite((s) => ({ ...s, loading: false }));
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const img = (key, fallback) => imgUrl(site.images[key]) || (site.loading ? "" : fallback);
  return <SiteContext.Provider value={{ ...site, img, reload: load }}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
